export const environment = {
  production: false,
  apiUrl: 'https://sportiq-finances-api.digi4dev.ma',
  baseDomain: 'sportiq-finances.digi4dev.ma',
  devFederationSlug: 'frmtt',
  version: '1.0.0'
};
